
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.11 18.89c-.863-.862-.291-2.671-.732-3.73C3.938 14.1 2.25 13.171 2.25 12c0-1.172 1.669-2.063 2.128-3.16.46-1.096-.131-2.868.731-3.73.863-.863 2.672-.291 3.732-.732C9.9 3.938 10.828 2.25 12 2.25c1.172 0 2.063 1.669 3.16 2.128 1.096.46 2.868-.131 3.73.731.863.863.291 2.672.732 3.732.44 1.059 2.128 1.987 2.128 3.159 0 1.172-1.669 2.063-2.128 3.16-.46 1.096.131 2.868-.731 3.73-.863.863-2.672.291-3.732.732-1.059.44-1.987 2.128-3.159 2.128-1.172 0-2.063-1.669-3.16-2.128-1.096-.46-2.868.131-3.73-.731z","stroke":"#EDC843","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    